import React from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import moment from 'moment';
import { DatePicker } from 'antd';
import '../../Payments/PaymentForm.scss';

interface ExportObject {
  showModal: boolean;
  source?: string | undefined;
  table: boolean;
  from: Date;
  to: Date;
  title: string;
  status: Number;
}


interface Props {
  t: any,
  handleModalClose: () => void,
  title: string | undefined,
  showModal: boolean,
  export: ExportObject,
  getDownloadFunction: any,
}

const ExportAndDownloadModal = (props: Props) => {
  const dateFormat = 'YYYY-MM-DD';
  return (
        <Modal show={props.showModal} onHide={props.handleModalClose} backdrop='static' keyboard={false} size='xl'>
          <Modal.Header closeButton>
            <Modal.Title>{props.title}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form.Group className='mb-3' controlId='from'>
              <Form.Label>{props.t('FROM')}</Form.Label>
              <DatePicker style={{ width: '100%' }} defaultValue={moment(props.export.from, dateFormat)} 
              onChange={(date: any) => {
                console.log(date._d);
                props.export.from = date._d;
              }} />
              {/* <Form.Control type='date' id='from' defaultValue={moment(props.export.from).format('YYYY-MM-DD')}
                onChange={(e: any) => {
                  props.export.from = e.target.valueAsDate;
                }} /> */}
            </Form.Group>
            <Form.Group className='mb-3' controlId='to'>
              <Form.Label>{props.t('TO')}</Form.Label>
               <DatePicker style={{ width: '100%' }} defaultValue={moment(props.export.to, dateFormat)}  onChange={(date: any) => {
                 props.export.to = date._d;
               }} />
               {/* <Form.Control type='date' id='to' defaultValue={moment(props.export.to).format('YYYY-MM-DD')}
                onChange={(e: any) => {
                  props.export.to = e.target.valueAsDate;
                }} />  */}
            </Form.Group>
          </Modal.Body>

          <Modal.Footer>
            <Button variant='secondary' onClick={props.handleModalClose}>{props.t('CANCEL')}</Button>
            <Button variant='primary' onClick={props.getDownloadFunction()}>{props.t('DOWNLOAD')}</Button>
          </Modal.Footer>
        </Modal>
  );
};

export default ExportAndDownloadModal;